import inView from 'in-viewport';

export default class Viewable {
  constructor(element) {
    this.element = element;
    inView(this.element, this.update.bind(this));
  }

  update() {
    this.element.classList.add('viewable');
  }
}
